// Constants in this file must be used in multiple places in the code.
export const FORCE_COPILOT_LISTING_TYPE = 'force/copilot';
